  <template>
  <v-container fluid class="ma-4">
    <div v-if="connectionsLoading">
    </div>
    <div v-else>
      <v-row>
        <v-avatar color="grey" class="mr-2" v-if="avatarImage">
          <v-img :src="avatarImage"></v-img>
        </v-avatar>
        <v-avatar color="accent" class="mr-2" v-else>
          {{ avatarLetters }}
        </v-avatar>
        <h3 class="ml-4">{{ name }}</h3>
      </v-row>
      <v-row>
        <v-divider class="mt-4 mb-4"></v-divider>
      </v-row>
      <v-row v-if="this.connection.entity.description">
        <div v-html="connection.entity.description"></div>
        <div class="mt-10 mb-10"></div>
      </v-row>
      <v-row v-if="documents.length">
        <h4 color='grey'>Documents</h4>
      </v-row>
      <v-row v-for="(d, i) in documents" :key="i">
        <v-container fluid>
          <v-row>
            {{d.name}}<a :href="d.location" class="ml-4"><v-icon>fa-file-pdf</v-icon></a>
          </v-row>
        </v-container>
      </v-row>
      <v-row v-if="documents.length">
        <div class="mb-10"></div>
      </v-row>
      <v-row>
        <v-btn @click="createConversation()">{{ chatLabel }}</v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { avatarImage, avatarLetters, displayName, primaryContactEmail } from '@/utils/entityDisplay'

export default {
  name: 'connectionDetails',
  props: { conid: String, connections: Array, connectionsLoading: Boolean },
  methods: {
    async createConversation () {
      const list = this.$store.getters['hearro/connections']
      const invitee = list.find(e => e.doc.id === this.conid)
      try {
        const id = await this.$store.dispatch('hearro/newConversation', { label: invitee.meta.name, participants: [invitee.doc.id] })
        console.log('new covnersation id', id)
        this.$router.push({ name: 'conversation', params: { cid: id } })
      } catch (e) {
        console.log(e.message)
      }
    }
  },
  computed: {
    connection () {
      return this.connections.find(c => c.doc.id === this.conid)
    },
    avatarImage () {
      return avatarImage(this.connection.entity)
    },
    avatarLetters () {
      return avatarLetters(this.connection.entity)
    },
    name () {
      return displayName(this.connection.entity)
    },
    primaryContactEmail () {
      return primaryContactEmail(this.connection.entity)
    },
    documents () {
      const docs = []
      if (!this.connection.entity.link) {
        return ''
      }
      this.connection.entity.link.forEach(e => {
        console.log(e)
        if (e.type === 'application/pdf') {
          docs.push(e)
        }
      })
      return docs
    },
    chatLabel () {
      if ((this.connection.entity.type || 0) === 0) {
        return 'chat'
      } else {
        return 'get support'
      }
    }
  }
}
</script>
